module.exports = "<svg version=\"1.0\" id=\"burger\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 100 100\" enable-background=\"new 0 0 100 100\" xml:space=\"preserve\"><g class=\"lignes\"><line class=\"haut\" fill=\"none\" stroke=\"#E30613\" x1=\"33\" y1=\"34\" x2=\"67\" y2=\"34\"></line><line class=\"milieu\" fill=\"none\" stroke=\"#E30613\" x1=\"33\" y1=\"50\" x2=\"67\" y2=\"50\"></line><line class=\"bas\" fill=\"none\" stroke=\"#E30613\" x1=\"33\" y1=\"66\" x2=\"67\" y2=\"66\"></line></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./fk.app/_src/burger-icon/burger.inline.svg
// module id = 17
// module chunks = 0